import type { CSSObject } from '@emotion/react'
import type { TFieldAssetType, TLngLat } from 'App/Map/types'
import { MapItemsCache } from 'components/GoogleMap/MapItemsCache'
import type { ReactComponentOverlayView } from 'components/GoogleMap/_utils/makeReactComponentOverlayView'
import { makeReactComponentOverlayView } from 'components/GoogleMap/_utils/makeReactComponentOverlayView'
import type { TBlockId } from 'stores/fieldAssetStore/helperTypes'
import type { TTrapBadgeComponentProps } from './TrapBadgeComponent/TrapBadgeComponent'
import { TrapBadgeComponent } from './TrapBadgeComponent/TrapBadgeComponent'

export type TRAP_META = {
  type: TFieldAssetType
  propertyId: string
  blockId: TBlockId
  lngLat: TLngLat
  name: string
  insectId?: number
  latLng: google.maps.LatLng
}

export type TTrapsValueTypesToPropsDictionary = Record<
  string,
  {
    children: string // normally we'd use ReactNode, but we're going to render to an svg
    getContainerCSS: () => CSSObject
  }
>

export class TrapValuesCache extends MapItemsCache<
  TRAP_META,
  TTrapsValueTypesToPropsDictionary,
  ReactComponentOverlayView<TTrapBadgeComponentProps>
> {
  constructor(options: { maps: typeof google.maps; map: google.maps.Map }) {
    super({
      createOverlay: (o) => {
        return makeReactComponentOverlayView({
          component: TrapBadgeComponent,
          latLng: o.meta.latLng,
          maps: o.maps,
          map: o.map,
          transform: 'translate(-50%, 0%)',
        })
      },
      renderOverlay: (o) => {
        o.overlay.render({ ...o, valueTypesToPropsDictionary: o.value })
      },
      hideOverlay: (o) => {
        o.overlay.setMap(null)
      },
      maps: options.maps,
      map: options.map,
    })
  }
}
